import { render, staticRenderFns } from "./SimilarCourses.vue?vue&type=template&id=e04aecf0&scoped=true&"
import script from "./SimilarCourses.vue?vue&type=script&lang=js&"
export * from "./SimilarCourses.vue?vue&type=script&lang=js&"
import style0 from "./SimilarCourses.vue?vue&type=style&index=0&id=e04aecf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04aecf0",
  null
  
)

export default component.exports